__turbopack_context__.v({
  "balance": "styles-module__IaasgW__balance",
  "balanceBox": "styles-module__IaasgW__balanceBox",
  "ctrl": "styles-module__IaasgW__ctrl",
  "generationIcon": "styles-module__IaasgW__generationIcon",
  "infoContainer": "styles-module__IaasgW__infoContainer",
  "infoHeader": "styles-module__IaasgW__infoHeader",
  "name": "styles-module__IaasgW__name",
});
